// Palette of the dashboard design, shared by its blocks.
export const COLORS = {
  green: "#235E4B",
  greenMid: "#3F8C6E",
  greenLight: "#6BBF9B",
  greenTint: "#E8F3EE",
  yellow: "#F2C94C",
  yellowTint: "#FFF8E5",
  red: "#E5484D",
  redTint: "#FDECEC",
  track: "#EEF1F0",
};

function numberLocale(locale) {
  return locale === "es" ? "es-ES" : "en-GB";
}

export function formatNumber(value, locale) {
  return Number(value || 0).toLocaleString(numberLocale(locale));
}

export function formatPercent(value, locale) {
  const number = Number(value || 0).toLocaleString(numberLocale(locale), {
    maximumFractionDigits: 1,
  });
  return `${number}%`;
}
